import apiClient from './apiClient';

export const getAccountInfo = (params) => {
    return apiClient.get('/account_info', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
};
export const createAccountInfo = (data) => {
    return apiClient.post('/account_info', data);
  };
  
  export const updateAccountInfo = (id, data) => {
    return apiClient.put(`/account_info/${id}`, data);
  };
  
  export const deleteAccountInfo = (id) => {
    return apiClient.delete(`/account_info/${id}`);
  };